import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import UserDashboardTable from './Components/UserDashboard/UserDashboardTable';
import Reviews from "./Components/UserDashboard/Reviews";
import { NavLink } from 'react-router-dom';
import MyEarnings from './Components/UserDashboard/MyEarnings';
import Refaral from './Components/UserDashboard/Refaral';
import UserRegistration from './Components/UserRegistration';
import axios from 'axios';

const UserDashboard = () => {
  const [activeForm, setActiveForm] = useState('dashboardtable');
  const [showRegistration, setShowRegistration] = useState(false);
  const [loading, setLoading] = useState(true);

  // check login status
  const checkGoogleLogin = async () => {
    try {
      const type = localStorage.getItem('googleLogin');
      const isGoogleLogin = JSON.parse(type);

      if (!isGoogleLogin) {
        setShowRegistration(false);
        setLoading(false);
        return;
      }

      const data = localStorage.getItem('userLogin');
      if (!data) {
        setShowRegistration(true);
        setLoading(false);
        return;
      }

      const details = JSON.parse(data);
      const payload = {
        username: details.name,
        email: details.email,
        password: details.email,
      };

      const response = await axios.post(
        'https://api.bakpoket.com/api/UserDetail1/Login',
        payload
      );

      if (response?.data) {
        localStorage.setItem('userDashboardLogin', JSON.stringify(response.data));
        // console.log(response)
        // localStorage.setItem('googleLogin', false);
        setShowRegistration(false);
      } else {
        setShowRegistration(true);
      }
    } catch (error) {
      console.error('Login failed:', error);
      setShowRegistration(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkGoogleLogin();
  }, []);

  // ✅ called from UserRegistration after successful register
  const handleRegistrationSuccess = () => {
    setShowRegistration(false);
  };

  if (loading) {
    return <p style={{ textAlign: "center", marginTop: "50px" }}>Loading...</p>;
  }

  if (showRegistration) {
    return <UserRegistration onRegistered={handleRegistrationSuccess} />;
  }

  return (
    <OuterWrapper>
      <InnerWrapper>
        <DashboardHeader>
          <LeftSection>
            <img src="/images/user-icon.png" alt="Logo" />
            <h1>User Dashboard</h1>
          </LeftSection>
        </DashboardHeader>

        <MainContainer>
          <Sidebar>
            <div className="top">
              <p
                className={activeForm === 'dashboardtable' ? 'active' : ''}
                onClick={() => setActiveForm('dashboardtable')}
              >
                Dashboard
              </p>
              <p
                className={activeForm === 'reviews' ? 'active' : ''}
                onClick={() => setActiveForm('reviews')}
              >
                Reviews
              </p>
              <p
                className={activeForm === 'myEarnings' ? 'active' : ''}
                onClick={() => setActiveForm('myEarnings')}
              >
                My Earnings
              </p>
              <p
                className={activeForm === 'referral' ? 'active' : ''}
                onClick={() => setActiveForm('referral')}
              >
                Referral
              </p>
              <p><NavLink to={'/contactus'} className='NavLink'>Contact Us</NavLink></p>
              <p><NavLink to={'/faqs'} className='NavLink'>FAQ's</NavLink></p>
            </div>
          </Sidebar>

          <MainContent>
            {activeForm === 'dashboardtable' && <UserDashboardTable />}
            {activeForm === 'reviews' && <Reviews />}
            {activeForm === 'myEarnings' && <MyEarnings />}
            {activeForm === 'referral' && <Refaral />}
          </MainContent>
        </MainContainer>
      </InnerWrapper>
    </OuterWrapper>
  );
};

export default UserDashboard;


// ---------------- STYLES ----------------

const OuterWrapper = styled.section`
  background-color: #fffff;
  padding: 30px 15px;
  display: flex;
  justify-content: center;

  .NavLink {
    color: white;
    text-decoration: none;
  }
`;

const InnerWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  border-radius: 30px;
  overflow: hidden;
  background-color: rgba(228, 232, 235, 0.88);
  font-family: Arial, sans-serif;
`;

const DashboardHeader = styled.div`
  background: linear-gradient(to right, #2a4157, #ef4766);
  padding: 15px 30px;
  color: white;
  display: flex;
  align-items: center;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  img {
    width: 40px;
  }

  h1 {
    font-size: 22px;
    margin: 0;
  }

  @media (max-width: 768px) {
    img {
      width: 24px;
    }
    h1 {
      font-size: 16px;
    }
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    flex-direction: row;
    overflow-x: auto;
  }
`;

const Sidebar = styled.div`
  background-color: #ef4766;
  width: 240px;
  padding: 30px;
  flex-shrink: 0;

  .top {
    display: flex;
    flex-direction: column;
    gap: 12px;

    p {
      color: white;
      margin: 0;
      font-size: 16px;
      cursor: pointer;
      padding: 6px 10px;
      border-radius: 6px;
      transition: background-color 0.2s ease, opacity 0.2s ease;

      &:hover {
        opacity: 0.8;
      }

      &.active {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
  }

  @media (max-width: 768px) {
    width: 100px;
    padding: 20px 10px;

    .top p {
      font-size: 10px;
      padding: 4px 3px;
    }
  }
`;

const MainContent = styled.div`
  flex: 1;
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;



